import device from '@deprecated-ui/_style/device';
import color from '@deprecated-ui/_style/color';
import styled, { css } from 'styled-components';
import NotPro from 'global/NotPro';
import { NotProWrapper } from 'global/NotPro/styled';

interface NotProProps {
  isPro?: boolean;
}

export const ValutionPageContainer = styled.div`
  position: relative;
  display: block;
  margin-right: unset;
`;

export const CustomNotProWrapper = styled(NotProWrapper)<NotProProps>`
  margin: 0 auto;
  max-width: none;

  ${({ isPro }) =>
    !isPro &&
    css`
      border: 1px solid ${color.gainsboro};
      border-radius: 2px;
      height: auto;
      max-width: 1000px;
    `}
`;

export const NotProContainer = styled(NotPro)`
  margin-top: 0px;
  padding: 50px 0;
  width: 100%;
`;
